$('body').on('click','.close-btn',function() {
  closePopup();
  outsideClickEnabled = false;
});
$('body').on('click','#custom-container',function(e) {
  e.stopPropagation(); // Prevent the document click handler from firing
  
  // Check if zdrawer is open - if so, don't open the color/snow load popup
  const zdrawer = document.querySelector('.zdrawer');
  if (zdrawer && zdrawer.classList.contains('open')) {
    console.log('Color/Snow load popup blocked: zdrawer is currently open');
    return; // Exit early without opening the popup
  }
  
  openPopup();
  if ($(this).hasClass('building-colors')) {
    // we show building colors, hide snow load
    $('.first-related-item').show();
    $('.related-title.color').show();
    $('.related-title.snowload').hide();
    $('.related-product-item.colors').show();
    $('.related-product-item.snowload').hide();
    $('.dekstech-option-name').text('Color');
  }
  else {
   // we show snow load, hide building colors
   $('.first-related-item').hide();
    $('.related-title.color').hide();
    $('.related-title.snowload').show();
        $('.related-product-item.colors').hide();
    $('.related-product-item.snowload').show();
    $('.dekstech-option-name').text('Snow Load');
  }
});

// Function to open the popup by adding the 'open' class
function openPopup() {
    document.getElementById('custom-popup').classList.add('open');
    // Enable the outside click handler after a short delay
    setTimeout(function() {
        enableOutsideClickHandler();
    }, 100);
}

// Function to close the popup by removing the 'open' class
function closePopup() {
    document.getElementById('custom-popup').classList.remove('open');
}

// Variable to control outside click handler
let outsideClickEnabled = false;

function enableOutsideClickHandler() {
    outsideClickEnabled = true;
}

// Close popup when clicking outside
$(document).on('click', function(event) {
    // Only process if the outside click handler is enabled
    if (!outsideClickEnabled) return;
    
    const popup = document.getElementById('custom-popup');
    const popupContent = popup ? popup.querySelector('.popup-content') : null;
    
    // Check if the popup is open and the click is outside the popup content
    if (popup && popup.classList.contains('open')) {
        // Close if clicking directly on the popup overlay background
        if (event.target === popup) {
            closePopup();
            outsideClickEnabled = false;
        }
        // Or if clicking outside the popup content (but not on the trigger)
        else if (!popupContent || (!popupContent.contains(event.target) && !$(event.target).closest('#custom-container').length)) {
            closePopup();
            outsideClickEnabled = false;
        }
    }
});

